import { ReactNode } from 'react';
// import { useTableInheritedProps } from '@rhino-project/core/hooks';

export interface HeaderProps {
  children?: ReactNode;
}

export const Header = ({ children }: HeaderProps) => {
  // const { inheritedProps } = useTableInheritedProps(props);

  return <>{children}</>;
};
